// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../../../node_modules/@types/google.maps/index.d.ts" />

import { mapAddressComponentsToAddress } from '@insify/global-google-maps';

import type { CountryCode } from '@insify/global-countries';
import type { SetOptional } from 'type-fest';

// TODO move address-related types to some global package because we just keep copying them over and over
type GeoLocation = {
  latitude: string;
  longitude: string;
};
export type Address = {
  street: string;
  streetAddition?: string;
  houseNumber: string;
  houseNumberAddition?: string;
  postalCode?: string;
  province?: string;
  city: string;
  country: CountryCode;
  geoLocation?: GeoLocation;
};
type LocationProfile = SetOptional<Address, 'street' | 'houseNumber'> & {
  purposes: string[];
  surfaceArea: number;
};

declare global {
  interface Window {
    google: {
      maps: typeof google.maps;
    };
    _GOOGLE_MAPS_INIT?: () => void;
    _GOOGLE_MAPS_LOADED?: Promise<void>;
  }
}

const init = (apiKey: string) => {
  if (window._GOOGLE_MAPS_LOADED === undefined) {
    window._GOOGLE_MAPS_LOADED = new Promise<void>((resolve, reject) => {
      window._GOOGLE_MAPS_INIT = resolve;

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=_GOOGLE_MAPS_INIT`;
      script.async = true;
      script.defer = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return window._GOOGLE_MAPS_LOADED;
};

const makeGoogleMaps = (key: string) => () => {
  return init(key).then(() => window.google.maps);
};

const mapGeocodingResultToLocationProfile = (
  result: google.maps.GeocoderResult,
  onPostalcodeMissing?: () => void,
): Partial<LocationProfile> => {
  return {
    ...mapAddressComponentsToAddress(result.address_components, onPostalcodeMissing),
    purposes: [],
    surfaceArea: 0,
  };
};

export { makeGoogleMaps, mapGeocodingResultToLocationProfile };
export * from './makeGoogleMapsRequesters';
